/* Accurized Series micrometer seating die - section behaviour.
   Vanilla JS, no dependencies, reduced-motion guarded.

   Everything is scoped to a section root rather than to document ids, so the
   section survives being placed twice on a page and re-initialises cleanly on
   a theme-editor section:load. */
(function () {
    'use strict';

    var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

    function init(root) {
        if (!root || root.dataset.dpInit === '1') return;
        root.dataset.dpInit = '1';

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /* -------------------------------------------- 1 - Scroll reveals -- */
        var reveals = root.querySelectorAll('.dp-reveal');
        if (reduce || !('IntersectionObserver' in window)) {
            each(reveals, function (el) { el.classList.add('dp-in'); });
        } else {
            var revealObs = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (!e.isIntersecting) return;
                    e.target.classList.add('dp-in');
                    revealObs.unobserve(e.target);
                });
            }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
            each(reveals, function (el) { revealObs.observe(el); });
        }

        /* ---------------------------------------- 2 - Hero die parallax --- */
        /* Applied to the <img> itself; the reveal transform lives on the
           wrapper, so the two never fight over the same property.          */
        var die = root.querySelector('[data-dp-hero-die]');
        var ticking = false;
        function parallax() {
            var y = window.pageYOffset || document.documentElement.scrollTop;
            if (die && y < window.innerHeight * 1.4) {
                die.style.transform = 'translate3d(0,' + (y * -0.07).toFixed(1) + 'px,0)';
            }
            ticking = false;
        }

        /* ------------------------------- 3 - Count-up hero statistics ---- */
        function fmtFor(el) {
            var dec    = parseInt(el.getAttribute('data-dec'), 10) || 0;
            var prefix = el.getAttribute('data-prefix') || '';
            var suffix = el.getAttribute('data-suffix') || '';
            var strip  = el.hasAttribute('data-strip-zero');   /* 0.001 -> .001 */
            return function (v) {
                var s = v.toFixed(dec);
                if (strip && s.indexOf('0.') === 0) s = s.slice(1);
                return prefix + s + suffix;
            };
        }
        function runCounter(el) {
            var target = parseFloat(el.getAttribute('data-count'));
            var fmt = fmtFor(el);
            var dur = 1100, t0 = null;
            function step(ts) {
                if (t0 === null) t0 = ts;
                var p = Math.min((ts - t0) / dur, 1);
                var eased = 1 - Math.pow(1 - p, 3);            /* easeOutCubic */
                el.textContent = fmt(target * eased);
                if (p < 1) requestAnimationFrame(step);
                else el.textContent = fmt(target);
            }
            requestAnimationFrame(step);
        }

        var counters = root.querySelectorAll('[data-count]');
        if (reduce || !('IntersectionObserver' in window)) {
            each(counters, function (el) { el.textContent = fmtFor(el)(parseFloat(el.getAttribute('data-count'))); });
        } else {
            var countObs = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (!e.isIntersecting) return;
                    runCounter(e.target);
                    countObs.unobserve(e.target);
                });
            }, { threshold: 0.6 });
            each(counters, function (el) { countObs.observe(el); });
        }

        /* ------------------------------------------ 4 - FAQ accordion ---- */
        var faq = root.querySelector('[data-dp-faq]');
        function faqClose(item) {
            item.classList.remove('dp-open');
            item.querySelector('.dp-faq-q').setAttribute('aria-expanded', 'false');
            item.querySelector('.dp-faq-a').style.maxHeight = '';
        }
        function faqOpen(item) {
            item.classList.add('dp-open');
            item.querySelector('.dp-faq-q').setAttribute('aria-expanded', 'true');
            var p = item.querySelector('.dp-faq-a');
            p.style.maxHeight = p.scrollHeight + 'px';
        }
        if (faq) {
            faq.addEventListener('click', function (ev) {
                var btn = ev.target.closest && ev.target.closest('.dp-faq-q');
                if (!btn || !faq.contains(btn)) return;
                var item = btn.parentElement;
                var wasOpen = item.classList.contains('dp-open');
                each(faq.querySelectorAll('.dp-faq-item'), faqClose);
                if (!wasOpen) faqOpen(item);
            });
            var first = faq.querySelector('.dp-faq-item.dp-open');
            if (first) faqOpen(first);
        }

        /* ------------------------ 5 - Sticky rail: after hero, before CTA - */
        var sticky = root.querySelector('[data-dp-sticky]');
        var hero   = root.querySelector('.dp-hero');
        var buyBox = root.querySelector('[data-dp-pricing]');
        var pastHero = false, atPricing = false;
        function syncSticky() {
            if (sticky) sticky.classList.toggle('dp-show', pastHero && !atPricing);
        }
        if ('IntersectionObserver' in window) {
            if (hero) new IntersectionObserver(function (e) {
                pastHero = !e[0].isIntersecting; syncSticky();
            }, { threshold: 0 }).observe(hero);
            if (buyBox) new IntersectionObserver(function (e) {
                atPricing = e[0].isIntersecting; syncSticky();
            }, { threshold: 0 }).observe(buyBox);
        }

        /* -------------------------------- 6 - Scroll + resize plumbing --- */
        if (!reduce) {
            window.addEventListener('scroll', function () {
                if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
            }, { passive: true });
            parallax();
        }

        var rt;
        window.addEventListener('resize', function () {
            clearTimeout(rt);
            rt = setTimeout(function () {
                var open = faq && faq.querySelector('.dp-faq-item.dp-open');
                if (open) {
                    var p = open.querySelector('.dp-faq-a');
                    p.style.maxHeight = p.scrollHeight + 'px';
                }
            }, 150);
        });
    }

    function boot() { each(document.querySelectorAll('[data-dp-accdie]'), init); }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    /* Theme editor: re-init when the section is re-rendered. */
    document.addEventListener('shopify:section:load', function (e) {
        var r = e.target.querySelector('[data-dp-accdie]');
        if (r) { delete r.dataset.dpInit; init(r); }
    });
})();
